import { render, staticRenderFns } from "./schoolImgBanner.vue?vue&type=template&id=b74ba9da"
import script from "./schoolImgBanner.vue?vue&type=script&lang=js"
export * from "./schoolImgBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports